export const DEFAULT_PROFILE_IMG =
  "https://brightmarbles.io/wp-content/uploads/2021/02/join-us.gif";
